const getText = (item) => {
  if (item.nameLocal) return item.nameLocal;
  if (item.name) return item.name;
  if (item.number) return item.number;
  return '';
};

const convertDropdownOptions = data => data.map(item => ({
  key: item.id,
  text: getText(item),
  value: item.id,
}));

export default convertDropdownOptions;
